module.exports = __webpack_public_path__ + "ede15c2583ace31d82494dd839755767.svg";